import { render } from "./UITranslations.vue?vue&type=template&id=1d9a26b5&scoped=true"
import script from "./UITranslations.vue?vue&type=script&lang=js"
export * from "./UITranslations.vue?vue&type=script&lang=js"

import "./UITranslations.vue?vue&type=style&index=0&id=1d9a26b5&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9a26b5"]])

export default __exports__